import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { SharesCatalogKey } from './shares.i18n.js';
import { SHARES_CATALOG } from './shares.i18n.js';

export type SharesMessageId = `shares:${SharesCatalogKey}`;

const PREFIX_LENGTH = 'shares:'.length;

/** `t()` for the stop-gap `shares:` scope (see `shares.i18n.ts`). */
export function useSharesT(): { t: (id: SharesMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: SharesMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as SharesCatalogKey;
      const raw = SHARES_CATALOG[locale][key] ?? SHARES_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
